class Samplerequest {
	constructor(config) {
		this.scopeElem = 'data-samplerequest';
		this.config = Object.assign({
			scope: `[${this.scopeElem}]`,
			indicator: '[data-samplerequest-indicator]',
			submitForm: '[data-samplerequest-submitform]',
			offcanvasFooter: '.offcanvas-footer'
		}, config);

		this.init();
	}

	init() {
		$(document).on('click', this.config.scope, this.addToCart.bind(this));
		$(document).on('click', '[data-samplerequests]', this.addToCartMultiple.bind(this));
	}

	addToCart(event) {
		event.preventDefault();
		let $button = $(event.currentTarget)

		$.ajax({
			url: $button.data('samplerequest-route'),
			method: 'POST',
			data: {
				action: 'addToCart',
				product_id: $button.data('samplerequest'),
			},
			success: this.onSuccess.bind(this, $button),
			error: this.onError.bind(this, $button),
		});
	}

	addToCartMultiple(event) {
		event.preventDefault();
		let $button = $(event.currentTarget)

		$.ajax({
			url: $button.data('samplerequest-route'),
			method: 'POST',
			data: {
				action: 'addToCartMultiple',
				product_ids: $button.data('samplerequests'),
			},
			success: this.onSuccess.bind(this, $button),
			error: this.onError.bind(this, $button),
		});
	}

	onSuccess($button, response) {
		this.refreshIndicator(response);
		this.showSuccessMessage(response);

		let $relButtons = $(`[${this.scopeElem}="${$button.data('samplerequest')}"]`)
		if (response.status) {
			$relButtons.addClass('active');
		} else {
			$relButtons.removeClass('active');
		}
	}

	onError($button, response) {
		let message = response.responseJSON.message;
		if (message) {
			this.showErrorMessage(message);
		} else {
			alert('Er is iets fout gegaan.')
		}
	}

	refreshIndicator(response) {
		$('[data-scope="staalAmount"]').each(function () {
			if (response.amount > 0) {
				$(this).html(response.amount);
			} else {
				$(this).html('');
			}
		});
	}

	showSuccessMessage(response) {
		if (response.message) {
			this.showMessage(response.message, 'success');
		}
	}

	showErrorMessage(message) {
		this.showMessage(message, 'danger')
	}

	showMessage(message, level = 'success') {
		let $toast = $('[data-scope="toast"]');
		$toast.removeClass('bg-success');
		$toast.removeClass('bg-danger');
		$toast.addClass(`bg-${level}`);
		let $content = $toast.find('[data-scope="content"]');
		$content.html(message);
		let toastEl = $toast.get(0);
		new bootstrap.Toast(toastEl).show();
		toastEl.addEventListener('hidden.bs.toast', () => {
			$content.html('');
		});
	};
}

export default new Samplerequest;
